import { useRef, useState } from "react";
import { FaRegPauseCircle, FaRegPlayCircle } from "react-icons/fa";
import { imageUrlFor } from "../lib/image-url";
import { SchemaVideoObject } from "./schema-video-object";

const renderVideo = ({
  vidButtonRef,
  vidRef,
  handleToggleVideo,
  mp4,
  webm,
  posterImage,
}) => {
  return (
    <>
      <video
        ref={vidRef}
        poster={posterImage}
        autoPlay
        loop
        muted
        className="absolute z-10 w-auto min-w-full min-h-full max-w-none video-bg"
      >
        {mp4 && <source src={mp4} type="video/mp4" />}
        {webm && <source src={webm} type="video/webm" />}
      </video>

      {vidRef.current && vidRef.current.paused ? (
        <button
          ref={vidButtonRef}
          className="playback absolute z-40 mr-8 mb-8 bottom-0 right-0"
          aria-label="Pause"
          onClick={() => {
            handleToggleVideo();
          }}
        >
          <FaRegPlayCircle className="text-white h-10 w-10" />
        </button>
      ) : (
        <button
          className="playback absolute z-40 mr-8 mb-8 bottom-0 right-0"
          aria-label="Pause"
          onClick={() => {
            handleToggleVideo();
          }}
        >
          <FaRegPauseCircle className="text-white h-10 w-10" />
        </button>
      )}
    </>
  );
};

const SanityVideoPlayer = ({
  videoPoster,
  videoMp4,
  videoWebm,
  metaDescription,
  title,
}) => {
  const posterImage =
    videoPoster && videoPoster.asset
      ? imageUrlFor(videoPoster.asset._id)
          .quality(70)
          .width(1920)
          .auto("format")
          .url()
      : false;
  const mp4 =
    videoMp4 && videoMp4.asset && videoMp4.asset.url
      ? videoMp4.asset.url
      : false;
  const webm =
    videoWebm && videoWebm.asset && videoWebm.asset.url
      ? videoWebm.asset.url
      : false;
  const [isPlaying, setIsPlaying] = useState(false);
  const vidRef = useRef(null);
  const vidButtonRef = useRef(null);
  const handlePlay = () => {
    vidRef.current.play();
    setIsPlaying(!isPlaying);
  };
  const handlePause = () => {
    vidRef.current.pause();
    setIsPlaying(!isPlaying);
  };
  const handleToggleVideo = () =>
    vidRef.current.paused ? handlePlay() : handlePause();
  return (
    <>
      {renderVideo({
        vidButtonRef,
        vidRef,
        handleToggleVideo,
        posterImage,
        mp4,
        webm,
      })}
      <SchemaVideoObject
        name={title}
        description={metaDescription}
        thumbnail={posterImage}
        embedUrl={mp4}
      />
    </>
  );
};

export default SanityVideoPlayer;
